<template>
  <div class="design-service-promo">
    <span class="design-service-promo__text">
      Need edits? Use our <strong>FREE</strong>&nbsp;
      <a href="#" class="design-service-promo__link" @click.prevent="handleDesignServiceClick">
        <strong>design service!</strong>
      </a>
    </span>
  </div>
</template>

<script setup>
const emit = defineEmits(["design-service-clicked"]);

const handleDesignServiceClick = () => {
  emit("design-service-clicked");
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";

.design-service-promo {
  border: 1px solid $primary-light;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  background-color: rgba($primary-light, 0.05);
  text-align: center;

  &__text {
    font-size: 14px;
    line-height: 18px;
    color: $dark-smoke-gray;
    font-family: var(--font-inter);
  }

  &__link {
    color: $primary-light;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: darken($primary-light, 10%);
      text-decoration: underline;
    }
  }
}
</style>
